{
  "id": "weekly-pm",
  "label": "Vecko-pm",
  "sectionOrder": ["Inrikes", "Utrikes", "Ekonomi", "Kultur och nöje", "Sport"],
  "defaultSpanDays": 6,
  "spanStartWeekday": 1,
  "titleFollowsSpan": true,
  "filingSection": "Inrikes",
  "dayGrouping": true,
  "dayHeading": "{DayName} den {longDate}",
  "planning": {
    "titlePattern": "TT:s inrikes vecko-pm v{week}",
    "slugline": "TT-inrikes-vecko-pmv{week}"
  },
  "memoTitlePattern": "TT:s inrikes vecko-pm den {dateRange}",
  "sources": [
    {
      "type": "event",
      "newsvalues": ["2", "3", "4", "5", "6"],
      "sections": ["Inrikes", "Utrikes", "Ekonomi", "Kultur och nöje"]
    }
  ],
  "postamble": [
    "Frågor besvaras av kalenderredaktör Elisabeth Modig som nås på 08-692 27 65 eller kalender@tt.se.",
    "TT:s kalender: https://tt.se/kalender/lista/",
    "TT Nyhetsbyrån"
  ],
  "blocks": [
    {
      "id": "events",
      "label": "Händelser",
      "preamble": ["Här är veckans viktigaste händelser:"],
      "grouping": "section",
      "itemOrder": "time",
      "item": {
        "headline": "{time} - {headline} {publicDescription}",
        "lines": []
      },
      "eventTitleSections": []
    }
  ]
}
